import { Component, OnInit ,ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AppSettings } from '../../app.constant';
import { SponserService } from '../../shared/services/sponser.service';
import { SponserTableComponent } from '../../private/tables/sponser-table/sponser-table.component';

@Component({
  selector: 'sponser',
  templateUrl: './sponser.component.html',
  styleUrls: ['./sponser.component.css']
})
export class SponserComponent implements OnInit {
  sponserForm:FormGroup;
  httpResponseMessage:any;
  submitted=false;
  post:any;
  errorMessage: String;
  sponserentity:any;
  SponserName:string = '';
  PK_SponserID:any = '';
  SponserCode:any = '';
  Address:string = '';
  buttonTitle:String =  'S A V E ';
  newtitle:String =" N E W ";

  @ViewChild(SponserTableComponent) sponsertable;
  constructor(
    private formbuilder:FormBuilder, 
    private sponserservice:SponserService,
    private snackBar: MatSnackBar) {  }

ngOnInit() {
    this.sponserForm = this.formbuilder.group({
      'PK_SponserID':['', ],
      'SponserCode':['', [Validators.required, Validators.maxLength(10)]],
      'SponserName':['', [Validators.required, Validators.maxLength(250)]],
      'Address':['', Validators.required]
    })
}

cleardata()
{
  this.sponserForm.reset();
}

public hasError = (controlName: string, errorName: string) =>{
  return this.sponserForm.controls[controlName].hasError(errorName);
}

postSponser(post) :void  {
  if(post.PK_SponserID!='' && post.PK_SponserID!=null) {
    this.updateSponser(post);
  }
  else{
   this.createSponser(post);
  }
}

createSponser(post) :void  {
  this.submitted=true;
  if (this.sponserForm.invalid) { return;  }
  this.post=JSON.stringify(post);
  this.sponserservice.postSponser(AppSettings.API_ENDPOINT+AppSettings.CreateSponser,this.post).subscribe(
        data =>
        { this.httpResponseMessage=data;
          this.openSnackBar( this.httpResponseMessage,'');
          this.sponserForm.reset();
     },
          error => this.errorMessage = <any>error)
}


updateSponser(post){
  if (this.sponserForm.invalid) { return;}
  this.post=JSON.stringify(post);
  this.sponserservice.updateSponser(AppSettings.API_ENDPOINT+AppSettings.UpdateSponser,this.post).subscribe(
    data =>
    { this.httpResponseMessage=data;
      this.openSnackBar( this.httpResponseMessage,'');
      this.sponserForm.reset();
 },
    error => this.errorMessage = <any>error)
}


receiveData($event) {
  this.sponserentity = $event
  this.SponserCode=(this.sponserentity[0].SponserCode).trim();
  this.PK_SponserID=this.sponserentity[0].PK_SponserID;
  this.SponserName=(this.sponserentity[0].SponserName).trim();
  this.Address=(this.sponserentity[0].Address).trim();
}

durationInSeconds = 2;
openSnackBar(message: string, action: string) {
  this.snackBar.open(message,action ,{
    duration: 2000,
    verticalPosition: 'bottom'
  });
}
}
